import { useState } from 'react';

interface LoadingProps {
  isLoading: boolean;
  startLoading: () => void;
  stopLoading: () => void;
}

const useLoading = (): LoadingProps => {
  const [isLoading, setIsLoading] = useState(false);

  const startLoading = () => {
    setIsLoading(true);
  };

  const stopLoading = () => {
    setIsLoading(false);
  };

  return { isLoading, startLoading, stopLoading };
};

export default useLoading;
